import { OrgByParent } from 'api/types/orgsApiTypes'
import { useOrgsByParent } from 'hooks/data/orgsHook'

// if display_name is null, we just want to use the org_name as the default
export const useDisplayOrg = (orgName: string | undefined) => {
  const { data: orgs } = useOrgsByParent()
  if (orgs === undefined || orgName === undefined) {
    return undefined
  }

  // First check parent orgs
  const parentOrg = orgs.find((o: OrgByParent) => o.org_name === orgName)
  if (parentOrg) {
    return parentOrg.org_display_name ?? parentOrg.org_name
  }

  // Then check child orgs (legal entities)
  for (const org of orgs) {
    const childOrg = org.children.find((child) => child.org_name === orgName)
    if (childOrg) {
      return childOrg.org_display_name ?? childOrg.org_name
    }
  }

  return undefined
}
